import { ICaseAmounts } from "us.collection.case/interfaces";
import { ISentenceRow } from "..";

/**
 * To get the metadata of the form amount rows
 * @param caseAmountDetails The case amounts details for the common values of the form
 * @returns array of amounts rows
 */
export const getSenteceRows = (caseAmountDetails:ICaseAmounts | undefined): ISentenceRow[] => [
    {
      heading: "MAIN_AMOUNT",
      amountLabel: caseAmountDetails?.mainAmount ?? 0,
      inputAmountName: "mainAmount",
      interestFromName: "mainAmountFromDate",
      interestRateName: "mainAmountRate",
      interestToName: undefined
    },
    {
      heading: "CASE_COST",
      amountLabel: caseAmountDetails?.caseCost ?? 0,
      inputAmountName: "caseCost",
      interestFromName: "caseCostFromDate",
      interestRateName: "caseCostRate",
      interestToName: undefined
    },
    {
      heading: "COLLECTION_FEE",
      amountLabel: caseAmountDetails?.collectionFee ?? 0,
      inputAmountName: "collectionFee",
      interestFromName: "collectionFeeFromDate",
      interestRateName: "collectionFeeRate",
      interestToName: undefined
    },
    {
      heading: "COURT_FEE",
      amountLabel: caseAmountDetails?.courtFee ?? 0,
      inputAmountName: "courtFee",
      interestFromName: undefined,
      interestRateName: undefined,
      interestToName: undefined
    },
    {
      heading: "OTHER_COSTS",
      amountLabel: caseAmountDetails?.otherCosts ?? 0,
      inputAmountName: "otherCosts",
      interestFromName: "otherCostsFromDate",
      interestRateName: "otherCostsRate",
      interestToName: undefined
    },
    {
      heading: "MAIN_AMOUNT_INTEREST",
      amountLabel: caseAmountDetails?.interest ?? 0,
      inputAmountName: "mainAmountInterest",
      interestFromName: undefined,
      interestRateName: "mainAmountInterestRate",
      interestToName: "mainAmountInterestToDate"
    },
    {
      heading: "INTEREST_OF_COSTS",
      amountLabel: caseAmountDetails?.interestCollection ?? 0,
      inputAmountName: "interestCollectionFee",
      interestFromName: undefined,
      interestRateName: "interestCollectionFeeRate",
      interestToName: "interestCollectionFeeTo"
    },
  ]